import api from "~/services/apis/antecipeApi";
import { formatDateInHoursAndMinutes } from '~/utils/date';

export const getMedicalDutys = async ({ startDate, endDate, crm, crmuf }) => {
  try {
    return api.get(
      `doctor/vacancies` +
        `?startDate=${startDate}&endDate=${endDate}&crm=${crm}&crmUf=${crmuf}`
    );
  } catch (e) {
    console.log("Error", e);
  }
};

export const syncDutyById = async (id) => {
  await api.put(`medicalcompany/vacancy/${id}/sync`)
}

const normalizeVacancy = (vacancy) => ({
  ...vacancy,
  real_start_hour: vacancy.real_start_hour ? formatDateInHoursAndMinutes(new Date(vacancy.real_start_hour)) : null,
  real_end_hour: vacancy.real_end_hour ? formatDateInHoursAndMinutes(new Date(vacancy.real_end_hour)) : null,
  verified_documents: Boolean(vacancy.verified_documents),
  can_advance: Boolean(vacancy.can_advance),
  is_checked: Boolean(vacancy.is_checked),
});

export const getPackageVacancies = async (id, { limit, offset }, { signal } = {}) => {
  const response = await api.get(`medicalcompany/doctorrequets/${id}/vacancies`, { params: { limit, offset }, signal });
  return { total: Number(response.data.total_items) || 0, rows: response.data.data.map(normalizeVacancy) };
};

export const ALL_VACANCIES_PAGE = 100;

export const fetchAllPackageVacancies = async (id) => {
  const rows = [];
  let offset = 0;
  let total = Infinity;
  while (offset < total) {
    const page = await getPackageVacancies(id, { limit: ALL_VACANCIES_PAGE, offset });
    total = page.total;
    rows.push(...page.rows);
    if (page.rows.length === 0) break;
    offset += ALL_VACANCIES_PAGE;
  }
  return rows;
};

const BATCH_FIELDS = [
  "verified_documents",
  "can_advance",
  "is_checked",
  "real_start_hour",
  "real_end_hour",
  "normal_payment_date",
  "payment_rule",
];

export const updateVacancyAdvances = async (items) => {
  if (!items.length) return [];
  const newVacancyValues = items.map((item) => {
    const clean = { id: item.id };
    BATCH_FIELDS.forEach((field) => {
      if (item[field] === undefined || item[field] === null) return;
      clean[field] = field === "normal_payment_date" ? String(item[field]).slice(0, 10) : item[field];
    });
    return clean;
  });
  const response = await api.put("medicalcompany/vacancyadvance/batch", { newVacancyValues });
  return response.data.data;
};
